import moment from "moment";
import { DateHelper } from "../../helper/helpers";

export const startOptions = [
  {
    id: 1,
    label: "Days",
    value: "d",
  },
  {
    id: 2,
    label: "Hours",
    value: "h",
  },
];
export const endOptions = [
  {
    id: 1,
    label: "Days",
    value: "days",
  },
  {
    id: 2,
    label: "Hours",
    value: "hours",
  },
];

export const cancelationOptions = [
  {
    id: 1,
    label: "Hours",
    value: "h",
  },
  {
    id: 2,
    label: "Minutes",
    value: "m",
  },
];

const validatedData = (dataArr) => {
  let validData = true;
  for (let data of dataArr) {
    const { bookingStart, bookingEnd, classTimes } = data;
    if (bookingStart && bookingEnd) {
      if (bookingStart >= bookingEnd)
        return "Booking window opening cannot be after booking window closing";
      if (bookingStart >= classTimes.from)
        return "Booking window opening cannot be after the class starting time";
      if (bookingEnd > classTimes.from + 1)
        return "Booking window end cannot be after class start time";
    }
  }
  return validData;
};

export const getClassDatesObject = (
  start,
  end,
  datesArr,
  startUnit,
  endUnit,
  cancelBefore,
  cancelationWindowUnit
) => {
  let returnedArr = datesArr.map((date) => {
    return {
      classTimes: date,
      lastCancelationTime:
        cancelationWindowUnit === "h"
          ? parseInt(
              moment(date.from)
                .subtract(`0${start}:00:00`)
                .format("x")
            )
          : parseInt(
              moment(date.from)
                .subtract(`00:0${cancelBefore}:00`)
                .format("x")
            ),
      bookingStart: !start
        ? 0
        : startUnit === "hours"
        ? parseInt(
            moment(date.from)
              .subtract(`0${start}:00:00`)
              .format("x")
          )
        : parseInt(
            moment(date.from)
              .subtract(start, startUnit)
              .format("x")
          ),
      bookingEnd: !end
        ? 0
        : endUnit === "hours"
        ? parseInt(
            moment(date.from)
              .subtract(`0${end}:00:00`)
              .format("x")
          )
        : parseInt(
            moment(date.to)
              .subtract(end, endUnit)
              .format("x")
          ),
    };
  });

  let isValidDataOrErrorMessage = validatedData(returnedArr);
  if (isValidDataOrErrorMessage !== true)
    throw new Error(isValidDataOrErrorMessage);
  return returnedArr;
};

export const checkIfTimesWithenTrainerSchedule = (
  classDays,
  scheduleDays,
  datesObj
) => {
  let outcome = {};
  for (let classDay of classDays) {
    let daySchedule = scheduleDays[classDay];
    console.log({ daySchedule });

    if (!daySchedule || !daySchedule.length) {
      outcome[classDay] = false;
      continue;
    }

    let allElementsFit = true;

    for (let element of datesObj[classDay]) {
      let fitsInAnyShift = daySchedule.some((trainersShift) => {
        return (
          DateHelper.isTimeInRange(
            element.start,
            trainersShift.start,
            trainersShift.end
          ) &&
          DateHelper.isTimeInRange(
            element.end,
            trainersShift.start,
            trainersShift.end
          )
        );
      });

      if (!fitsInAnyShift) {
        allElementsFit = false;
        break;
      }
    }

    outcome[classDay] = allElementsFit;
  }

  return !Object.values(outcome).includes(false);
};

export const minAndMaxRange = (timesArray) => {
  // Initialize minTime and maxTime with the first range
  let minTime = timesArray[0].from;
  let maxTime = timesArray[0].to;

  // Iterate through the array and update minTime and maxTime accordingly
  timesArray.forEach((timeRange) => {
    if (timeRange.from < minTime) {
      minTime = timeRange.from;
    }
    if (timeRange.to > maxTime) {
      maxTime = timeRange.to;
    }
  });
  return {
    from: minTime,
    to: maxTime,
  };
};
